import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { useStateValue } from '../../state'

export const EditDeploymentModal = ({ show, toggle, deployment }) => {
  const [currentState, dispatch] = useStateValue()
  const [stateObj, setStateObj] = useState(deployment)

  useEffect(() => {
    if (deployment) {
      if (deployment.data && !deployment.data.snap) {
        deployment.data.snap = {
          institutionCourses: '',
          usesInstitutionCourses: false,
          shouldConnectToSourceCourse: false,
        }
      }
      setStateObj(deployment);
    }
  }, [deployment]);


  const commitStateObject = async () => {
    try {
      // switch data for mydata for update; See Item structure in dserv project
      const fullStateObj = { ...stateObj, mydata: stateObj.data }
      const resp = await client.post(
        `/account/admin_lti13.editDeployment/-/${currentState.issuer.id}/${currentState.client.id}/${deployment.id}`,
        fullStateObj
      )
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully edited the deployment."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      dispatch({ type: 'updateDeployment', deployment: resp.data.deployment })
    } catch (err) {
      console.log(err)
      let errMsg = "There was an error trying to update the Platform Instance."
      if (err.response) {
        errMsg = `Error: ${err.response.data.error}`
      }
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content={errMsg}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    } finally {
      toggle(!show)
    }
  }

  const handleChange = e => {
    const nextStateObj = { ...stateObj }

    if (e.target.type == 'checkbox') {
      nextStateObj[e.target.name] = e.target.checked
    } else {
      nextStateObj[e.target.name] = e.target.value
    }
    setStateObj(nextStateObj)
  }

  const handleDataChange = e => {
    const { data } = { ...stateObj }

    const { name, value, type, checked } = e.target
    if (type === 'checkbox') {
      data[name] = checked
    } else {
      data[name] = value
    }
    const nextStateObj = { ...stateObj, data }
    setStateObj(nextStateObj)
  }

  const handleDataSnapChange = e => {
    const { data } = { ...stateObj }

    const { name, value, type, checked } = e.target
    if (type === 'checkbox') {
      data.snap[name] = checked
    } else {
      data.snap[name] = value
    }
    const nextStateObj = { ...stateObj, data }
    setStateObj(nextStateObj)
  }

  const helpTextStyle = {
    fontSize: "0.8em",
    color: "#6B5400"
  }

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Platform Instance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup controlId="name">
          <ControlLabel>Name:</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataChange}
            name="name"
            value={stateObj && stateObj.data.name ? stateObj.data.name : ''}
          />
        </FormGroup>
        <FormGroup controlId="deploymentid">
          <ControlLabel>Deployment ID:</ControlLabel>
          <FormControl
            type="text"
            onChange={handleChange}
            name="deploymentid"
            disabled={true}
            value={stateObj && stateObj.deploymentid ? stateObj.deploymentid : ''}
          />
        </FormGroup>
        <FormGroup controlId="useSourceCourse">
          <ControlLabel>Use Source Course on Init:</ControlLabel>
          <Checkbox
            className="ml-2 mb-4"
            inline
            onChange={handleDataSnapChange}
            name="shouldConnectToSourceCourse"
            checked={stateObj && stateObj.data.snap && stateObj.data.snap.shouldConnectToSourceCourse ? true : false}
          />
          <div style={helpTextStyle}>
            If checked, will connect the selected course instead of duplicate a new one from the selection
          </div>
        </FormGroup>
        <FormGroup controlId="institutionCourses">
          <ControlLabel>Use Institution Courses:</ControlLabel>
          <Checkbox
            className="ml-2 mb-4"
            inline
            onChange={handleDataSnapChange}
            name="usesInstitutionCourses"
            checked={stateObj && stateObj.data.snap && stateObj.data.snap.usesInstitutionCourses ? true : false}
          />
          <div style={helpTextStyle}>
            If checked, use the list defined below instead of the users course memberships to populate the course list
          </div>
        </FormGroup>

        <FormGroup controlId="institutionCourses">
          <ControlLabel>Institution Courses:</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataSnapChange}
            name="institutionCourses"
            value={stateObj && stateObj.data.snap && stateObj.data.snap.institutionCourses ? stateObj.data.snap.institutionCourses : ''}
          />
          <div style={helpTextStyle}>
            Comma separated list of coursenums to use in conjunction with the above option
          </div>
        </FormGroup>

        <FormGroup controlId="institutionManagers">
          <ControlLabel>Institution Managers:</ControlLabel>
          <FormControl
            type="text"
            onChange={handleDataSnapChange}
            name="institutionManagers"
            value={stateObj && stateObj.data.snap && stateObj.data.snap.institutionManagers ? stateObj.data.snap.institutionManagers : ''}
          />
          <div style={helpTextStyle}>
            Comma separated list of emails that if seen will be given the manager role during an LTI 1.3 launch
          </div>
        </FormGroup>

        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => commitStateObject()}
        >
          <div className="far fa-plus fa-fw mr-2" /> Update
        </div>
      </Modal.Body>
    </Modal>
  )
}

EditDeploymentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  deployment: PropTypes.object
}
